'use client'

import { Button } from '@/components/ui/button'
import { useAuthSession } from '@/hooks/use-auth-session'
import { useModalStore } from '@/stores/modal-store'
import { useTranslations } from 'next-intl'
import { UserMenu } from './user-menu'

export function LoginButton() {
	const { authenticated, email } = useAuthSession()
	const { openModal } = useModalStore()
	const t = useTranslations('header')

	if (authenticated) {
		return <UserMenu email={email} />
	}

	return (
		<Button
			onClick={() => openModal('auth')}
			className="min-h-[40px] cursor-pointer rounded-[8px] bg-brand-blue px-[16px] py-[12px] font-medium text-[14px] text-white leading-[100%] hover:bg-brand-blue/90"
		>
			{t('logIn')}
		</Button>
	)
}
